import React from 'react';
import { StarIcon } from 'lucide-react';
export function StarDivider() {
  return <div className="flex items-center justify-center gap-3 py-8" data-id="element-188">
      <div className="h-px w-16 bg-soft-blue/30" data-id="element-189" />
      <StarIcon className="w-4 h-4 text-gold" data-id="element-190" />
      <div className="h-px w-16 bg-soft-blue/30" data-id="element-191" />
    </div>;
}